
export default {
  'ORDER' (state) {
    return state.order
  },
  'ORDERS' (state) {
    return state.orders
  }
}
